var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Summary',{attrs:{"debtData":_vm.debtData}}),_c('DebtPayRelatedList',{attrs:{"hideAction":_vm.debtData.ReceiveDebtTotal === 0,"items":_vm.debtData.DebtPayList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }